<template>
  <div class="launchpack-delivery">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"
    >
      <div slot="month" class="flex-align">
        <div class="flex-align" style="margin-right:12px;">
          <div v-for="(day, day_idx) in dayItems"
               class="unselect day-item"
               :class="{'selected': day.selected}"
               @click="selectDay(day)"
               :key="`day-${day_idx}`">{{ day.label }}</div>
        </div>
        <div style="align-items: center;">
          <admin-date-picker
            style="display: inline-block;margin-bottom:0"
            type="month"
            :data="filtered.start"
            @setDate="selectStartMonth"></admin-date-picker>
        </div>
        <div style="display:inline-block;margin: 0 8px;font-size: 18px;color:#064160">&#126;</div>
        <div>
          <admin-date-picker
            style="display: inline-block;margin-bottom:0"
            type="month"
            :data="filtered.end"
            @setDate="selectEndMonth"></admin-date-picker>
        </div>
      </div>

      <div slot="partner" v-if="$store.getters.mode!=='partner'">
        <lp-adm-drop-input :data.sync="partners"
                           @onSelect="selectPartnerFilter"
                           placeholder="검색 후 선택"
                           listAlign="left"
                           width="250px"
                           style="margin-top:12px;"></lp-adm-drop-input>
      </div>
    </admin-filter>

    <div class="box">
      <admin-box-item title="매출 현황">
        <div class="flex-align" style="width:600px;">
          <div class="sales-situation-box" style="background-color:#f5f5f5;width:40%">
            <div>총 매출 금액</div>
            <div>{{ total_price - refund_price | currency }}</div>
          </div>
          <div class="sales-situation-box" style="width:30%;">
            <div>총 결제 금액</div>
            <div>{{ total_price | currency }}</div>
          </div>
          <div class="sales-situation-box" style="width:30%;">
            <div>환불 금액</div>
            <div>{{ refund_price | currency }}</div>
          </div>
        </div>
      </admin-box-item>
    </div>

    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @check="clickCheckBox"
                 :table_width="1100"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <td slot="date" slot-scope="props">{{ props.item.date }}</td>
      <td slot="order_count" slot-scope="props">{{ props.item.order_count }}</td>
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>
      <td slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</td>
      <td slot="coupon_price" slot-scope="props">{{ props.item.coupon_price | currency }}</td>
      <td slot="point" slot-scope="props">{{ props.item.point | currency }}</td>
      <td slot="delivery_cost" slot-scope="props">{{ props.item.delivery_cost | currency }}</td>
      <td slot="total_price" slot-scope="props">{{ props.item.total_price | currency }}</td>
      <td slot="refund_price" slot-scope="props">{{ props.item.refund_price | currency }}</td>
      <td slot="sales_price" slot-scope="props">{{ (props.item.total_price - props.item.refund_price) | currency }}</td>

    </order-table>

  </div>
</template>

<script>
  import MartMixin from "@/mixins/MartMixin"
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import moment from "moment";

  export default {
    name: 'MartOrderStatisticsMonth',
    components: {LpAdmDropInput},
    mixins: [
      MartMixin
    ],
    data () {
      return {
        total_price: 0,
        refund_price: 0,
        dayItems:[{
          label:'1개월',
          selected: false
        },{
          label:'3개월',
          selected: true
        },{
          label:'6개월',
          selected: false
        },{
          label:'12개월',
          selected: false
        }]
      }
    },
    watch: {

    },
    created() {
      this.init();

      this.$axios.get('public/service/internal-plugin')
        .then(res => {
          if (res.status === 200) {

            let plugin = res.data.internal_plugin;

            if(plugin.indexOf('point_coupon')>-1) {
              let coupon_price = find(this.tableData, 'eng_name', 'coupon_price');
              let point_price = find(this.tableData, 'eng_name', 'point_price');
              if(!coupon_price && !point_price) {
                let idx = this.tableData.findIndex(item => item.eng_name === 'discount_price');
                this.tableData.splice(idx+1, 0, {
                  eng_name: 'coupon_price',
                  ko_name: '쿠폰 할인',
                  width: '120px'
                });
                this.tableData.splice(idx+2, 0, {
                  eng_name: 'point',
                  ko_name: '적립금 사용',
                  width: '120px'
                });
              }
            }
          }
        });

    },
    methods: {
      async init() {
        await this.initializing('order_statistics_month', 'mart/order/statistics/month');
        await this.getSales();
        this.filtered.start = moment().subtract(3, 'months').format('YYYY-MM-DD');
      },
      async getDataFromServer() {
        await this.getData();
        await this.getSales();
      },
      getSales() {
        this.$axios.get(this.getUrl('mart/order/sales/month'), {
          params: this.filtered
        }).then(res => {
          this.total_price = res.data.total_price;
          this.refund_price = res.data.refund_price;
        })
      },
      selectPartnerFilter(res) {
        this.filtered.partner_id = res.value;
        this.getDataFromServer();
      },
      selectStartMonth(res) {
        let list = res.split('-');
        this.filtered.start = list[0] + '-' + list[1];
        this.initDayItem();
        this.getDataFromServer();
      },
      selectEndMonth(res) {
        let list = res.split('-');
        this.filtered.end = list[0] + '-' + list[1];
        this.initDayItem();
        this.getDataFromServer();
      },
      selectDay (day) {
        this.initDayItem();
        day.selected=true;
        let nowTime = moment();
        this.filtered.end = nowTime.format('YYYY-MM');
        // item.end.value =
        // this.filtered[item.end.key

        switch(day.label) {
          case '1개월':
            this.filtered.start = nowTime.subtract(1, 'months').format('YYYY-MM');
            break;
          case '3개월':
            this.filtered.start = nowTime.subtract(3, 'months').format('YYYY-MM');
            break;
          case '6개월':
            this.filtered.start = nowTime.subtract(6, 'months').format('YYYY-MM');
            break;
          case '12개월':
            this.filtered.start = nowTime.subtract(12, 'months').format('YYYY-MM');
            break;
        }
        this.filtered.page_num=1;
        this.getDataFromServer();
      },
      initDayItem() {
        this.dayItems.forEach(day => {
          day.selected = false;
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .launchpack-delivery td
    border 1px solid #dbdbdb

  .delivery-info
    position absolute
    left -170px
    top 38px
    background #eee
    z-index 10
    padding 8px
    width 240px

  .delivery-info
    display none

  .delivery-section:hover .delivery-info
    display block

  .sales-situation-box
    text-align center
    border 2px solid #ddd
    color #363636
    border-right 0

  .sales-situation-box:last-child
    border-right 2px solid #ddd

  .sales-situation-box > div:first-child
    border-bottom 2px solid #ddd

  .sales-situation-box > div
    padding 9.5px

  .sales-situation-box > div:last-child
    font-weight bold
    font-size 15px
  .day-item
    font-size 14px
    text-align center
    width 51px
    height 31px
    line-height 31px
    color #363636
    border 1px solid #dbdbdb
    border-radius 4px
    margin-right 2px

  .day-item.selected
    color $primary
    border 1px solid $primary
</style>
